import {
  canUseNavigator,
  DeviceSettings as DeviceSettingsSdk,
  getTrackingDeviceType,
  getTrackingOs,
  type Locale,
} from 'invictus-sdk-typescript'
import UAParser from 'ua-parser-js'

import { DEFAULT_LOCALE } from '@Constants/locale'

export type AppIdType = 'front-web' | 'next'

type GetDeviceSettingsProps = {
  appId?: AppIdType
  locale?: Locale
}

const SSR_FALLBACK_VALUE = 'NC (SSR)'

const isSsr = (appId: AppIdType) => appId === 'next'

export const getDeviceSettings = ({
  appId = 'front-web',
  locale = DEFAULT_LOCALE,
}: GetDeviceSettingsProps = {}): DeviceSettingsSdk => {
  const userAgent = !isSsr(appId) && canUseNavigator() && new UAParser(window.navigator.userAgent)
  const userOs = userAgent && userAgent.getOS()

  return new DeviceSettingsSdk(
    locale,
    'web',
    appId,
    (typeof process !== 'undefined' && process.env.ACCOUNT_TYPE) || 'production',
    userOs ? getTrackingOs(userOs.name, userOs.version) : SSR_FALLBACK_VALUE,
    userAgent ? getTrackingDeviceType(userAgent.getDevice().type) : SSR_FALLBACK_VALUE,
    (typeof process !== 'undefined' && process.env.ENV_NAME) || 'master',
  )
}
